import { useState } from "react";

// Shown only on iOS Safari when the app is NOT already installed as a home-screen app.
// Face ID, payments, and the register all work in the installed PWA (iOS 16.4+ WebAuthn).
export const IOSInstallBanner = ({ label = "Install on this iPhone" }) => {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("ios_install_dismissed") === "1");
  if (dismissed) return null;
  const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent);
  const isSafari = /Safari/.test(navigator.userAgent) && !/CriOS|FxiOS|EdgiOS/.test(navigator.userAgent);
  const isStandalone = window.navigator.standalone === true
    || window.matchMedia("(display-mode: standalone)").matches;
  if (!isIOS || !isSafari || isStandalone) return null;
  return (
    <div
      data-testid="ios-install-banner"
      className="rounded-xl border border-amber-500/40 bg-stone-900/80 p-4 space-y-2"
    >
      <div className="flex items-center justify-between">
        <span className="mono-tag text-[10px] uppercase tracking-widest text-amber-500">
          {label}
        </span>
        <button
          type="button"
          data-testid="ios-install-dismiss"
          onClick={() => { localStorage.setItem("ios_install_dismissed", "1"); setDismissed(true); }}
          className="text-stone-500 hover:text-stone-300 text-xs"
        >
          ✕
        </button>
      </div>
      <p className="text-[11px] text-stone-300 leading-relaxed">
        Tap <span className="text-amber-400 font-semibold">Share</span> (the square with an arrow at the
        bottom of Safari), then <span className="text-amber-400 font-semibold">Add to Home Screen</span>.
        It opens full-screen with Face ID — exactly like a native app.
      </p>
      <p className="text-[10px] text-stone-500">
        Prefer the App Store? <a data-testid="ios-appstore-link" href="https://apps.apple.com/app/id6753765418" target="_blank" rel="noopener noreferrer" className="text-amber-500 hover:underline">Get the native iOS app</a>.
      </p>
    </div>
  );
};
